<template>
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="33" height="33" rx="16.5" fill="url(#paint0_linear_1_5353)" />
    <path
      d="M18.6248 9.95833L10.953 17.6301L10.953 17.6301C10.7283 17.8549 10.6159 17.9673 10.5444 18.1063C10.4729 18.2452 10.4467 18.402 10.3945 18.7155L9.53158 23.8929C9.47912 24.2076 9.45289 24.365 9.54387 24.456C9.63484 24.5469 9.79222 24.5207 10.107 24.4683L15.2843 23.6054L15.2843 23.6054C15.5978 23.5531 15.7546 23.527 15.8936 23.4555C16.0326 23.3839 16.1449 23.2716 16.3697 23.0468L16.3697 23.0468L24.0415 15.375C25.2584 14.1581 25.8669 13.5496 25.917 12.8C25.9229 12.7112 25.9229 12.6221 25.917 12.5334C25.8669 11.7837 25.2584 11.1753 24.0415 9.95833C22.8246 8.74141 22.2161 8.13295 21.4665 8.08287C21.3777 8.07694 21.2886 8.07694 21.1999 8.08287C20.4502 8.13295 19.8418 8.74141 18.6248 9.95833Z"
      fill="white"
    />
    <path
      d="M17.3761 11.2071L10.953 17.6301L10.953 17.6301C10.7283 17.8549 10.6159 17.9673 10.5444 18.1063C10.4729 18.2452 10.4467 18.402 10.3945 18.7155L9.53158 23.8929C9.47912 24.2076 9.45289 24.365 9.54387 24.456C9.63484 24.5469 9.79222 24.5207 10.107 24.4683L15.2843 23.6054C15.5978 23.5531 15.7546 23.527 15.8936 23.4555C16.0326 23.3839 16.145 23.2716 16.3697 23.0468L22.7927 16.6238C23.1261 16.2904 23.2927 16.1238 23.2927 15.9167C23.2927 15.7096 23.1261 15.5429 22.7927 15.2096L18.7903 11.2071C18.4569 10.8738 18.2903 10.7071 18.0832 10.7071C17.8761 10.7071 17.7094 10.8738 17.3761 11.2071Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_5353"
        x1="14.175"
        y1="-9.3"
        x2="42.6926"
        y2="-2.17059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
